import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col"
}
const _hoisted_2 = { class: "flex-1 overflow-y-auto p-6 space-y-6" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center py-20"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-red-50 border-2 border-red-200 rounded-xl p-8 text-center"
}
const _hoisted_5 = { class: "text-red-600" }
const _hoisted_6 = { class: "bg-gray-50 rounded-xl p-5 border border-gray-200" }
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_10 = { class: "flex items-center gap-2 mt-1" }
const _hoisted_11 = { class: "text-base font-semibold text-gray-800" }
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = {
  key: 1,
  class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-semibold bg-gray-100 text-gray-500 border-2 border-gray-300"
}
const _hoisted_14 = { class: "mt-1" }
const _hoisted_15 = {
  key: 1,
  class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-semibold bg-gray-100 text-gray-500 border-2 border-gray-300"
}
const _hoisted_16 = { class: "md:col-span-2" }
const _hoisted_17 = { class: "flex items-center gap-2 mt-1" }
const _hoisted_18 = { class: "text-gray-700" }
const _hoisted_19 = { class: "bg-gray-50 rounded-xl p-5 border border-gray-200" }
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_21 = { class: "text-base font-semibold text-gray-800 mt-1" }
const _hoisted_22 = { class: "text-gray-700 mt-1" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "md:col-span-2" }
const _hoisted_26 = { class: "text-gray-700 mt-1" }
const _hoisted_27 = { class: "bg-gray-50 rounded-xl p-5 border border-gray-200" }
const _hoisted_28 = { class: "text-lg font-bold text-gray-900 mb-4 flex items-center gap-2" }
const _hoisted_29 = { class: "hidden md:block overflow-x-auto" }
const _hoisted_30 = { class: "w-full" }
const _hoisted_31 = { class: "divide-y divide-gray-200" }
const _hoisted_32 = { class: "py-3 px-3 font-semibold text-gray-800" }
const _hoisted_33 = { class: "py-3 px-3 text-center text-gray-700" }
const _hoisted_34 = { class: "py-3 px-3 text-center" }
const _hoisted_35 = { class: "inline-flex items-center justify-center w-10 h-7 bg-indigo-100 text-indigo-800 rounded-lg font-bold text-sm" }
const _hoisted_36 = { class: "py-3 px-3 text-right font-bold text-gray-900" }
const _hoisted_37 = { class: "md:hidden space-y-3" }
const _hoisted_38 = { class: "font-bold text-gray-900 mb-2 text-sm" }
const _hoisted_39 = { class: "grid grid-cols-2 gap-2 text-xs" }
const _hoisted_40 = { class: "font-semibold text-gray-800" }
const _hoisted_41 = { class: "font-semibold text-indigo-600" }
const _hoisted_42 = { class: "col-span-2 pt-2 border-t border-gray-200" }
const _hoisted_43 = { class: "font-bold text-base text-gray-900" }
const _hoisted_44 = { class: "mt-4 pt-4 border-t-2 border-gray-300" }
const _hoisted_45 = { class: "flex justify-between items-center" }
const _hoisted_46 = { class: "text-2xl font-bold text-blue-600" }

import { usePedidosDetalles } from "@/modules/pedidos/composables";
import { ref, computed, watch } from "vue";

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'ModelDetallePedido',
  props: {
    isOpen: { type: Boolean },
    pedidoId: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Emits
const emit = __emit;

// Cargar datos del pedido solo cuando se abre el modal
const pedidoIdRef = ref(props.pedidoId || "");
const shouldFetch = computed(() => props.isOpen && !!props.pedidoId);

// Cargar datos del pedido
const { data, isLoading, isError, error, refetch } =
  usePedidosDetalles(pedidoIdRef);

// Watch para actualizar el ID cuando cambie
watch(
  () => props.pedidoId,
  (newId) => {
    if (newId) {
      pedidoIdRef.value = newId;
      if (props.isOpen) {
        refetch();
      }
    }
  }
);

// Computed para acceder a los datos
const pedido = computed(() => data.value?.data);
const productos = computed(() => pedido.value?.data.GpedPedidoProducto || []);

// Cerrar modal
const closeModal = () => {
  emit("close");
};

// Formato de moneda
const formatCurrency = (amount: string | number) => {
  return new Intl.NumberFormat("es-PE", {
    style: "currency",
    currency: "PEN",
  }).format(Number(amount));
};

// Formato de fecha
const formatDate = (date: string) => {
  return new Date(date).toLocaleString("es-PE", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Color del badge según el estado
const getEstadoColor = (estado: string) => {
  const estados: Record<string, string> = {
    completado: "bg-green-100 text-green-800 border-green-200",
    pendiente: "bg-yellow-100 text-yellow-800 border-yellow-200",
    procesando: "bg-blue-100 text-blue-800 border-blue-200",
    cancelado: "bg-red-100 text-red-800 border-red-200",
  };
  return (
    estados[estado.toLowerCase()] || "bg-gray-100 text-gray-800 border-gray-200"
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-backdrop" }, {
    default: _withCtx(() => [
      (__props.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/60 backdrop-blur-sm z-40 flex items-center justify-center p-4",
            onClick: _withModifiers(closeModal, ["self"])
          }, [
            _createVNode(_Transition, { name: "modal-content" }, {
              default: _withCtx(() => [
                (__props.isOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createElementVNode("div", { class: "bg-gray-900 px-6 py-4 flex items-center justify-between" }, [
                        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-2xl font-bold text-white flex items-center gap-2" }, [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-7 w-7",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            })
                          ]),
                          _createTextVNode(" Detalles del Pedido ")
                        ], -1)),
                        _createElementVNode("button", {
                          onClick: closeModal,
                          class: "text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
                        }, [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-6 w-6",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M6 18L18 6M6 6l12 12"
                            })
                          ], -1)
                        ]))])
                      ]),
                      _createElementVNode("div", _hoisted_2, [
                        (_unref(isLoading))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
                              _createElementVNode("div", { class: "text-center" }, [
                                _createElementVNode("div", { class: "inline-block animate-spin rounded-full h-16 w-16 border-4 border-indigo-600 border-t-transparent" }),
                                _createElementVNode("p", { class: "mt-4 text-gray-600 font-medium" }, " Cargando información... ")
                              ], -1)
                            ]))]))
                          : (_unref(isError))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _cache[3] || (_cache[3] = _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  class: "h-16 w-16 text-red-500 mx-auto mb-4",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                  })
                                ], -1)),
                                _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-xl font-semibold text-red-800 mb-2" }, " Error al cargar el pedido ", -1)),
                                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(error)?.message || "No se pudo obtener la información"), 1)
                              ]))
                            : (pedido.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createElementVNode("div", _hoisted_6, [
                                    _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-lg font-bold text-gray-900 mb-4 flex items-center gap-2" }, [
                                      _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        class: "h-5 w-5 text-blue-600",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        })
                                      ]),
                                      _createTextVNode(" Información General ")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_7, [
                                      _createElementVNode("div", null, [
                                        _cache[5] || (_cache[5] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-600 uppercase" }, "Estado", -1)),
                                        _createElementVNode("div", _hoisted_8, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass([getEstadoColor(pedido.value.data.estadoPedido.nombre), "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-bold border-2"])
                                          }, _toDisplayString(pedido.value.data.estadoPedido.nombre), 3)
                                        ]),
                                        _createElementVNode("p", _hoisted_9, _toDisplayString(pedido.value.data.estadoPedido.descripcion), 1)
                                      ]),
                                      _createElementVNode("div", null, [
                                        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-600 uppercase" }, "Método de Pago", -1)),
                                        _createElementVNode("div", _hoisted_10, [
                                          _cache[6] || (_cache[6] = _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-5 w-5 text-blue-600",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor"
                                          }, [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                                            })
                                          ], -1)),
                                          _createElementVNode("span", _hoisted_11, _toDisplayString(pedido.value.data.metodoPago.nombre), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", null, [
                                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-600 uppercase" }, "Tipo de Comprobante", -1)),
                                        _createElementVNode("div", _hoisted_12, [
                                          (pedido.value.data.tipoComprobante)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: _normalizeClass(["inline-flex items-center px-3 py-1.5 rounded-full text-sm font-semibold", 
                          pedido.value.data.tipoComprobante === 'Factura'
                            ? 'bg-blue-100 text-blue-700 border-2 border-blue-300'
                            : 'bg-green-100 text-green-700 border-2 border-green-300'
                        ])
                                              }, _toDisplayString(pedido.value.data.tipoComprobante), 3))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_13, " N/A "))
                                        ])
                                      ]),
                                      _createElementVNode("div", null, [
                                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-600 uppercase" }, "Método de Compra", -1)),
                                        _createElementVNode("div", _hoisted_14, [
                                          (pedido.value.data.metodoCompra)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: _normalizeClass(["inline-flex items-center px-3 py-1.5 rounded-full text-sm font-semibold", 
                          pedido.value.data.metodoCompra === 'Entrega a Domicilio'
                            ? 'bg-indigo-100 text-indigo-700'
                            : 'bg-teal-100 text-teal-700'
                        ])
                                              }, _toDisplayString(pedido.value.data.metodoCompra), 3))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_15, " N/A "))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_16, [
                                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-600 uppercase" }, "Fecha de Pedido", -1)),
                                        _createElementVNode("div", _hoisted_17, [
                                          _cache[10] || (_cache[10] = _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-5 w-5 text-gray-500",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor"
                                          }, [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                            })
                                          ], -1)),
                                          _createElementVNode("span", _hoisted_18, _toDisplayString(formatDate(pedido.value.data.createdAt)), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_19, [
                                    _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "text-lg font-bold text-gray-900 mb-4 flex items-center gap-2" }, [
                                      _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        class: "h-5 w-5 text-blue-600",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                        })
                                      ]),
                                      _createTextVNode(" Cliente ")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_20, [
                                      _createElementVNode("div", null, [
                                        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-600 uppercase" }, "Nombre", -1)),
                                        _createElementVNode("p", _hoisted_21, _toDisplayString(pedido.value.data.cliente.nombreCliente) + " " + _toDisplayString(pedido.value.data.cliente.apellidoCliente), 1)
                                      ]),
                                      _createElementVNode("div", null, [
                                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-600 uppercase" }, "Documento", -1)),
                                        _createElementVNode("p", _hoisted_22, _toDisplayString(pedido.value.data.cliente.nroDocumento), 1)
                                      ]),
                                      _createElementVNode("div", null, [
                                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-600 uppercase" }, "Teléfono", -1)),
                                        _createElementVNode("a", {
                                          href: `tel:${pedido.value.data.cliente.telefono}`,
                                          class: "text-blue-600 hover:underline mt-1 block"
                                        }, _toDisplayString(pedido.value.data.cliente.telefono), 9, _hoisted_23)
                                      ]),
                                      _createElementVNode("div", null, [
                                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-600 uppercase" }, "Correo", -1)),
                                        _createElementVNode("a", {
                                          href: `mailto:${pedido.value.data.cliente.correoCliente}`,
                                          class: "text-blue-600 hover:underline mt-1 block truncate"
                                        }, _toDisplayString(pedido.value.data.cliente.correoCliente), 9, _hoisted_24)
                                      ]),
                                      _createElementVNode("div", _hoisted_25, [
                                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-600 uppercase" }, "Dirección", -1)),
                                        _createElementVNode("p", _hoisted_26, _toDisplayString(pedido.value.data.cliente.direccionCliente), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("h3", _hoisted_28, [
                                      _cache[19] || (_cache[19] = _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        class: "h-5 w-5 text-blue-600",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                                        })
                                      ], -1)),
                                      _createTextVNode(" Productos (" + _toDisplayString(productos.value.length) + ") ", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("table", _hoisted_30, [
                                        _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
                                          _createElementVNode("tr", { class: "border-b-2 border-gray-300" }, [
                                            _createElementVNode("th", { class: "text-left py-2 px-3 text-xs font-bold text-gray-600 uppercase" }, " Producto "),
                                            _createElementVNode("th", { class: "text-center py-2 px-3 text-xs font-bold text-gray-600 uppercase" }, " Precio "),
                                            _createElementVNode("th", { class: "text-center py-2 px-3 text-xs font-bold text-gray-600 uppercase" }, " Cant. "),
                                            _createElementVNode("th", { class: "text-right py-2 px-3 text-xs font-bold text-gray-600 uppercase" }, " Subtotal ")
                                          ])
                                        ], -1)),
                                        _createElementVNode("tbody", _hoisted_31, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productos.value, (item) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: item.id,
                                              class: "hover:bg-white/50"
                                            }, [
                                              _createElementVNode("td", _hoisted_32, _toDisplayString(item.producto.nombreProducto), 1),
                                              _createElementVNode("td", _hoisted_33, _toDisplayString(formatCurrency(item.producto.precioProducto)), 1),
                                              _createElementVNode("td", _hoisted_34, [
                                                _createElementVNode("span", _hoisted_35, _toDisplayString(item.cantidad), 1)
                                              ]),
                                              _createElementVNode("td", _hoisted_36, _toDisplayString(formatCurrency(item.total)), 1)
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productos.value, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: item.id,
                                          class: "bg-white rounded-lg p-3 border border-gray-200"
                                        }, [
                                          _createElementVNode("h4", _hoisted_38, _toDisplayString(item.producto.nombreProducto), 1),
                                          _createElementVNode("div", _hoisted_39, [
                                            _createElementVNode("div", null, [
                                              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-gray-600" }, "Precio:", -1)),
                                              _createElementVNode("p", _hoisted_40, _toDisplayString(formatCurrency(item.producto.precioProducto)), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-gray-600" }, "Cantidad:", -1)),
                                              _createElementVNode("p", _hoisted_41, _toDisplayString(item.cantidad), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_42, [
                                              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-gray-600" }, "Subtotal:", -1)),
                                              _createElementVNode("p", _hoisted_43, _toDisplayString(formatCurrency(item.total)), 1)
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]),
                                    _createElementVNode("div", _hoisted_44, [
                                      _createElementVNode("div", _hoisted_45, [
                                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-lg font-bold text-gray-800" }, "TOTAL:", -1)),
                                        _createElementVNode("span", _hoisted_46, _toDisplayString(formatCurrency(pedido.value.data.totalPedido)), 1)
                                      ])
                                    ])
                                  ])
                                ], 64))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", { class: "bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end gap-3" }, [
                        _createElementVNode("button", {
                          onClick: closeModal,
                          class: "px-6 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold rounded-lg transition-colors"
                        }, " Cerrar ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})